export default function getUserInfo(userID){
    let userInfo = app.store.getById("u2diUserInfo",userID);

    if(userInfo){
        return userInfo;
    }else{
        return app.store.getById("u2diUserInfoList",userID);
    }
}
